export const OMITTED_PROPS = [
  "widgetLastChange",
  "updateWidgetMetaProperty",
  "invalidProps",
  "widgetId",
  "validationMessages",
  "isLoading",
  "internalMaxWidth",
  "dynamicBindingPathList",
  "dynamicTriggerPathList",
  "dragDisabled",
  "dropDisabled",
  "bindingPaths",
  "disablePropertyPane",
  "evaluatedValues",
  "resizeDisabled",
  "isDeletable",
  "isDefaultClickDisabled",
  "docsUrl",
  "appMode",
  "parentId",
  // layouts
  "gridColumns",
  "gridRows",
  "left",
  "top",
  // table widget
  "derivedColumns",
  "cachedColumnSettings",
  // page/modal/slideout widget
  "routes",
  "sections",
  // section widget
  "columns",
  "stackColumnsAt",
  // menus
  "childrenType",
];
